import React, { useState } from 'react';
import { Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import Controls from './controls/Controls';
import { AdminButtons, AccountantButtons, ManagerButtons, SupervisorButtons, SupervisorAccountantButtons } from './RoleButtons';

const ActionButtons = ({
    roles,
    isDesktop,
    accountingSettlement,
    activeClients,
    selectedAccountant,
    contactId,
    handleOpenConfirmDialog,
    openApproveForPaymentDialog,
    canAddBlock,
    handleOpenAddBlockDialog,
    canAddAdditionalFee,
    handleOpenAdditionalFeeDialog,
    isStatementEdited,
    getStatementChangeLog,
    selectedMonth,
    selectedYear
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const role = roles?.find(r => r);

    const commonProps = {
        accountingSettlement,
        activeClients,
        handleOpenConfirmDialog,
        openApproveForPaymentDialog,
        canAddBlock,
        handleOpenAddBlockDialog,
        canAddAdditionalFee,
        handleOpenAdditionalFeeDialog,
        handleClose
    };

    let RoleMenuContent = null;

    switch (role) {
        case 'ADMIN':
        case 'ADMIN_SUPERVISOR':
            RoleMenuContent = <AdminButtons {...commonProps} />;
            break;
        case 'ACCOUNTANT':
        case 'CHIEF_ACCOUNTANT':
            RoleMenuContent = <AccountantButtons {...commonProps} />;
            break;
        case 'MANAGER':
            RoleMenuContent = <ManagerButtons {...commonProps} />;
            break;
        case 'SUPERVISOR':
            RoleMenuContent = <SupervisorButtons {...commonProps} />;
            break;
        case 'SUPERVISOR_ACCOUNTANT':
            RoleMenuContent = <SupervisorAccountantButtons
                {...commonProps}
                selectedAccountant={selectedAccountant}
                contactId={contactId}
            />;
            break;
        default:
            RoleMenuContent = null;
    }

    const showGenerateReport = (
        roles?.includes('SUPERVISOR') ||
        roles?.includes('SUPERVISOR_ACCOUNTANT') ||
        roles?.includes('ADMIN') ||
        roles?.includes('ADMIN_SUPERVISOR') ||
        roles?.includes('ACCOUNT_MANAGER') ||
        roles?.includes('MANAGER')
    ) && isStatementEdited;

    const hasVisibleChildren = (children) => {
        let hasItem = false;
        React.Children.forEach(children, child => {
            if (!child) return;
            if (React.isValidElement(child)) {
                if (child.type === React.Fragment) {
                    if (hasVisibleChildren(child.props.children)) {
                        hasItem = true;
                    }
                } else if (typeof child.type === 'function') {
                    const rendered = child.type(child.props);
                    if (hasVisibleChildren(rendered)) {
                        hasItem = true;
                    }
                } else {
                    hasItem = true;
                }
            }
        });
        return hasItem;
    };

    const hasRoleActions = hasVisibleChildren(RoleMenuContent);
    const hasAnyActions = hasRoleActions || Boolean(showGenerateReport);

    return (
        <>
            <Controls.PremiumButton
                variant="blue"
                label="Akcje"
                onClick={handleClick}
                icon="fas fa-caret-down"
            />
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    sx: {
                        mt: 1,
                        minWidth: 220,
                        borderRadius: '8px',
                        boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
                    }
                }}
            >
                {hasAnyActions ? (
                    <>
                        {RoleMenuContent}

                        {showGenerateReport && (
                            <MenuItem onClick={() => { handleClose(); getStatementChangeLog(selectedAccountant, selectedMonth, selectedYear); }}>
                                <ListItemIcon>
                                    <i className="fas fa-file-alt" style={{ color: '#10b981', fontSize: '1.2rem' }}></i>
                                </ListItemIcon>
                                <ListItemText primary="Generuj raport zmian" />
                            </MenuItem>
                        )}
                    </>
                ) : (
                    <MenuItem disabled sx={{ fontStyle: 'italic', color: 'text.secondary', opacity: '0.7 !important' }}>
                        <ListItemText primary="Brak dostępnych akcji" />
                    </MenuItem>
                )}
            </Menu>
        </>
    );
};

export default ActionButtons;